// extracted by mini-css-extract-plugin
export var arrows = "_3f-6";
export var decrementer = "_3f-a";
export var disabled = "_3f-4";
export var error = "_3f-1";
export var hiddenText = "_3f-b";
export var incrementer = "_3f-9";
export var input = "_3f-8";
export var inputWrapper = "_3f-0";
export var leadingIcon = "_3f-c";
export var readonly = "_3f-3";
export var regular = "_3f-7";
export var small = "_3f-5";
export var warning = "_3f-2";